import { useState } from 'react';
export function useDerivedState(propValue, compute = v => v) {
    const [previousPropValue, setPreviousPropValue] = useState(propValue);
    const [value, setValue] = useState(() => compute(propValue, undefined));
    if (previousPropValue !== propValue) {
        setValue(state => compute(propValue, state));
        setPreviousPropValue(propValue);
    }
    return [value, setValue];
}
//# sourceMappingURL=index.js.map